import { createContext, useContext } from "react";

import type { Gesture, Point } from "../types.ts";

export type ZoomUnaryIncrement = -1 | 1;

export type ZoomContext = {
  zoom: number;
  zoomOrigin: Point;
  zoomSteps: readonly number[];
  onZoomStep: (delta: ZoomUnaryIncrement) => void;
  onZoomChange: (zoom: number) => void;
  onZoomWheel: (zoom: number, origin: Point) => void;
  onZoomReset: () => void;
  onZoomGesture: (gesture?: Gesture) => void;
};

export const ZoomContext = createContext<ZoomContext | undefined>(undefined);
ZoomContext.displayName = "ZoomContext";

export const useZoom = () => {
  const zoomContext = useContext(ZoomContext);
  if (!zoomContext) {
    throw new Error(`Expected ZoomContext in component tree.`);
  }
  return zoomContext;
};
